import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Eye, AlertTriangle } from 'lucide-react';

const CybersecurityServices = () => {
  const services = [
    {
      icon: <Shield size={40} />,
      title: 'Zero Trust Architecture',
      description: 'Implement comprehensive zero-trust security frameworks that verify every user and device.',
      features: ['Identity verification', 'Device compliance', 'Network segmentation', 'Continuous monitoring']
    },
    {
      icon: <Lock size={40} />,
      title: 'Threat Intelligence',
      description: 'Advanced threat detection and response using AI-powered security analytics.',
      features: ['Real-time monitoring', 'Behavioral analysis', 'Incident response', 'Threat hunting']
    },
    {
      icon: <Eye size={40} />,
      title: 'Security Assessment',
      description: 'Comprehensive security audits and penetration testing services.',
      features: ['Vulnerability assessment', 'Penetration testing', 'Compliance auditing', 'Risk analysis']
    },
    {
      icon: <AlertTriangle size={40} />,
      title: 'Incident Response',
      description: '24/7 security operations center with rapid incident response capabilities.',
      features: ['24/7 SOC monitoring', 'Forensic analysis', 'Recovery planning', 'Compliance reporting']
    }
  ];

  return (
    <div className="service-page">
      <div className="container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Cybersecurity Services</h1>
          <p>Protect your enterprise with advanced cybersecurity solutions and zero-trust architecture.</p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul>
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CybersecurityServices;